import React from 'react';
import PropTypes from 'prop-types';
import quoteIcon from 'assets/images/quote.svg';

const GeneratorReview = ({ quote, author = 'Anonymous Customer' }) => (
  <div className="single-review">
    <img className="single-review__quote-icon" src={quoteIcon} alt="quote" />
    <div className="single-review__quote">{quote}</div>
    <div className="single-review__author">- {author}</div>
  </div>
);

GeneratorReview.propTypes = {
  quote: PropTypes.string.isRequired,
  author: PropTypes.string,
};

export default GeneratorReview;



// WEBPACK FOOTER //
// ./src/views/Home/components/GeneratorReviews/GeneratorReview.js